import { render, staticRenderFns } from "./checkbox-field.vue?vue&type=template&id=331b6375&scoped=true&"
import script from "./checkbox-field.vue?vue&type=script&lang=ts&"
export * from "./checkbox-field.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox-field.vue?vue&type=style&index=0&id=331b6375&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331b6375",
  null
  
)

export default component.exports